"use client";
import React, { FC } from "react";
import Link from "next/link";
import { useTranslations } from "next-intl";
import classNames from "classnames";
import { useTheme } from "@/context/Theme.context";
import { ShowWhen } from "../show-when/show-when";
import { Theme } from "@/enums";
import { usePathname } from "next/navigation";
import { apiRequest } from "@/utils/apiRequest";
import { SEND_PARCEL_ENABLED } from "@/configs/config";

type TProps = {
  list: { title: string; href: string }[];
  className?: string;
  isParcels?: boolean;
};

export const handleSendParcel = async () => {
  const response = await apiRequest("common/get-data-login-to-boxette", "get");

  const boxetteLoginUrl = response?.data?.data?.urlToLoginInBoxette;

  if (!boxetteLoginUrl) {
    console.error("Boxette login URL not found");
    return;
  }

  window.location.href = boxetteLoginUrl;
};

const InnerNavigation: FC<TProps> = ({ list, className, isParcels }) => {
  const pathname = usePathname();
  const theme = useTheme();

  const t = useTranslations();

  const isActive = (href: string) => {
    if (isParcels) {
      return pathname.includes(href.split("/")[2]);
    }
    return pathname.includes(href);
  };

  return (
    <ul className={classNames("h-full pt-4", className)}>
      {list.map((item, index) => (
        <li
          key={index}
          className={classNames(
            "relative inline-flex h-[56px] items-center overflow-hidden px-7",
            {
              "active-parcel-btn-gradient-ge text-cyan-400":
                isActive(item.href) && theme !== Theme.UK,
              "active-parcel-btn-gradient-uk text-[#eb7623]":
                isActive(item.href) && theme === Theme.UK,
              "text-gray-500": !isActive(item.href),
            },
          )}
        >
          {index === 0 || SEND_PARCEL_ENABLED ? (
            <Link href={item.href} className="uppercase">
              {t(item.title)}
            </Link>
          ) : (
            <div
              className="cursor-pointer uppercase"
              onClick={handleSendParcel}
            >
              <p>{t(item.title)}</p>
            </div>
          )}

          <ShowWhen condition={isActive(item.href)}>
            <div
              className={classNames(
                "absolute bottom-[0] left-0 h-1 w-full rounded-tl-sm rounded-tr-sm",
                {
                  "bg-cyan-400": theme !== Theme.UK,
                  "bg-[#eb7623]": theme === Theme.UK,
                },
              )}
            />
          </ShowWhen>
        </li>
      ))}
    </ul>
  );
};

export { InnerNavigation };
